DialogController = App.loadClass 'core::Angular/DialogController'

class exports.ContextController extends DialogController
    constructor: (@scope, @transitions, @data, @modalInstance, @quote) ->
        super(@scope, @transitions, @modalInstance)

        @scope.title = 'Quote Context'
        @scope.quote = @quote

        @loadScopeData @data.getSelf(), 'self'

    save: () =>
        @data.saveContext(@scope.quote.id, @scope.quote.context).then () =>
            @modalInstance.close()
